import React from "react";

const PoweredBy = () => {
  return (
    <div className="flex flex-col justify-center mt-5 text-xs text-center gap-1">
      <span className="font-medium mb-2 text-sm">⚠️ RefMan vi saluta!</span>
      <span>Nella stagione 2026/2027 verrà sostituito da FIP Analytics a livello nazionale</span>
      <span>Le utenze verranno disabilitate a partire da luglio 2026</span>
      <span className="font-medium mt-2">Grazie per aver usato Referee Manager Platform 🤙🏻</span>
    </div>
  );
};

export default PoweredBy;
